module.exports = __webpack_public_path__ + "static/img/08.e94cd2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/08.jpg
// module id = uZ+/
// module chunks = 0